/* AMTENDENCY — favoritos.
   Guarda uma lista de handles no localStorage e mantém em sincronia os botões
   de coração dos cards e o contador do ícone no header. Sem dependência.
   A página /pages/wish-list lê a mesma chave (ver sections/am-favoritos.liquid). */
(function () {
  var CHAVE = 'amt:favs';

  function ler() {
    try {
      var v = JSON.parse(localStorage.getItem(CHAVE));
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      // localStorage bloqueado (modo privado/terceiros) ou valor corrompido:
      // favoritos viram sessão-só, o resto do site segue funcionando.
      return [];
    }
  }

  function gravar(lista) {
    try {
      localStorage.setItem(CHAVE, JSON.stringify(lista));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('am:favoritos', { detail: { lista: lista } }));
  }

  function contar(lista) {
    var alvo = document.querySelector('[data-am-fav-count]');
    if (!alvo) return;
    alvo.textContent = lista.length ? String(lista.length) : '';
    alvo.hidden = lista.length === 0;
  }

  function pintar() {
    var lista = ler();
    document.querySelectorAll('[data-am-fav]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', lista.indexOf(btn.dataset.amFav) > -1 ? 'true' : 'false');
    });
    contar(lista);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-am-fav]');
    if (!btn) return;
    // o card inteiro é um link em overlay — sem isto o clique navega
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.amFav;
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i > -1) lista.splice(i, 1);
    else lista.push(handle);

    gravar(lista);
    pintar();

    // pulso curto só ao SALVAR (ao remover, o coração some suave e basta)
    if (i === -1) {
      btn.classList.remove('am-produto__fav--pulsa');
      void btn.offsetWidth; // reinicia a animação se clicarem em sequência
      btn.classList.add('am-produto__fav--pulsa');
      setTimeout(function () { btn.classList.remove('am-produto__fav--pulsa'); }, 500);
    }
  });

  // outra aba mexeu na lista
  window.addEventListener('storage', function (e) {
    if (e.key === CHAVE) pintar();
  });

  document.addEventListener('DOMContentLoaded', pintar);
  // a PLP re-renderiza o grid ao filtrar: os botões novos nascem sem estado
  document.addEventListener('am:grid-render', pintar);
  if (document.readyState !== 'loading') pintar();

  window.amFavoritos = { ler: ler, gravar: gravar, pintar: pintar, CHAVE: CHAVE };
})();

/* "Ver como": densidade da grade da coleção. Escreve as duas variáveis de
   coluna no próprio #product-grid e lembra a escolha.

   O `data-am-modo` existe porque o CSS do modo lista dependia de
   `[style*='--am-cols-desktop: 1']` — um seletor que quebra com qualquer
   mudança de espaçamento na serialização do style. */
(function () {
  var CHAVE = 'amt:cols';

  function aplicar(n, marcar) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.style.setProperty('--am-cols-desktop', n);
      // no celular só existem 1 e 2 colunas; 3 e 4 caem para 2
      grid.style.setProperty('--am-cols-mobile', n === '1' ? '1' : '2');
      grid.setAttribute('data-am-modo', n === '1' ? 'lista' : 'grade');
    }
    if (!marcar) return;
    document.querySelectorAll('.am-modos__btn').forEach(function (b) {
      var ativo = b.dataset.amCols === String(n);
      b.classList.toggle('is-ativo', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });
  }

  function restaurar() {
    if (!document.querySelector('.am-modos')) return;
    var n = null;
    try { n = localStorage.getItem(CHAVE); } catch (e) {}
    // sem escolha guardada, vale o padrão da seção (já no HTML)
    if (n) aplicar(n, true);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.am-modos__btn');
    if (!btn) return;
    var n = btn.dataset.amCols;
    try { localStorage.setItem(CHAVE, n); } catch (e2) {}
    aplicar(n, true);
  });

  document.addEventListener('DOMContentLoaded', restaurar);
  // o facets.js troca o grid inteiro ao filtrar/ordenar
  document.addEventListener('am:grid-render', restaurar);
  if (document.readyState !== 'loading') restaurar();
})();

/* Dropdown de ordenação: pilota o <select> do Dawn, que segue no DOM porque
   o facets.js monta os parâmetros lendo o form por ID. */
(function () {
  function fechar(raiz) {
    raiz.dataset.aberto = 'false';
    var b = raiz.querySelector('[data-am-ordenar-botao]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function fecharTodos(exceto) {
    document.querySelectorAll('[data-am-ordenar]').forEach(function (r) {
      if (r !== exceto) fechar(r);
    });
  }

  document.addEventListener('click', function (e) {
    var alvo = e.target;

    var botao = alvo.closest && alvo.closest('[data-am-ordenar-botao]');
    if (botao) {
      var raiz = botao.closest('[data-am-ordenar]');
      var abrindo = raiz.dataset.aberto !== 'true';
      fecharTodos(raiz);
      raiz.dataset.aberto = abrindo ? 'true' : 'false';
      botao.setAttribute('aria-expanded', abrindo ? 'true' : 'false');
      return;
    }

    var opcao = alvo.closest && alvo.closest('[data-am-ordenar-valor-opcao]');
    if (opcao) {
      var r2 = opcao.closest('[data-am-ordenar]');
      var valor = opcao.dataset.amOrdenarValorOpcao;

      r2.querySelectorAll('.am-ordenar__opcao').forEach(function (o) {
        var ativa = o === opcao;
        o.classList.toggle('is-ativa', ativa);
        o.setAttribute('aria-selected', ativa ? 'true' : 'false');
      });
      var rotulo = r2.querySelector('[data-am-ordenar-valor]');
      if (rotulo) rotulo.textContent = opcao.textContent.trim();
      fechar(r2);

      // é o `input` no <select> que faz o facets.js buscar e re-renderizar
      var sel = document.getElementById('SortBy');
      if (sel && sel.value !== valor) {
        sel.value = valor;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    fecharTodos(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fecharTodos(null);
    // Enter/Espaço numa opção equivalem ao clique
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-am-ordenar-valor-opcao]')) {
      e.preventDefault();
      e.target.click();
    }
  });
})();
